import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupItemTemplatesApi = {
    getTrialGroupItemTemplates: (groupId: number): Observable<Dtos.GetTrialGroupItemTemplatesResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupItemTemplates = new Dtos.GetTrialGroupItemTemplates();

        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupItemTemplatesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupItemTemplateById: (id: number): Observable<Dtos.GetTrialGroupItemTemplateByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupItemTemplateById = new Dtos.GetTrialGroupItemTemplateById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupItemTemplateByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialGroupItemTemplate: (trialGroupItemTemplate: Dtos.TrialGroupItemTemplate, collection: Dtos.Collection): Observable<Dtos.SetTrialGroupItemTemplateResponse> => {

        let request: Dtos.SetTrialGroupItemTemplate = new Dtos.SetTrialGroupItemTemplate();

        request.trialGroupItemTemplate = trialGroupItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.SetTrialGroupItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialGroupItemTemplate: (groupId: number): Observable<Dtos.CreateTrialGroupItemTemplateResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialGroupItemTemplate = new Dtos.CreateTrialGroupItemTemplate();

        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.CreateTrialGroupItemTemplateResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialGroupItemTemplate: (trialGroupItemTemplate: Dtos.TrialGroupItemTemplate, collection: Dtos.Collection): Observable<Dtos.ValidateTrialGroupItemTemplateResponse> => {

        let request: Dtos.ValidateTrialGroupItemTemplate = new Dtos.ValidateTrialGroupItemTemplate();

        request.trialGroupItemTemplate = trialGroupItemTemplate;
        request.collection = collection;

        // send request
        const response: Promise<Dtos.ValidateTrialGroupItemTemplateResponse> = client.post(request);

        return Observable.from(response);

    },
}